import { useEffect, useState } from 'react';

const useViewportWidth = () => {
  const [viewportWidth, setViewportWidth] = useState(null);

  useEffect(() => {
    const handleResize = () => {
      setViewportWidth(window.innerWidth);
    };

    // Set initial viewport width
    setViewportWidth(window.innerWidth);

    // Attach the event listener
    window.addEventListener('resize', handleResize);

    // Clean up the event listener
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return viewportWidth;
};

export default useViewportWidth;
